import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

// Helper to access custom palette colours without IMikeTheme
type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    darkGrey?: { main: string }
    mediumGrey?: { main: string }
  }
}

export const StyledDialogContent = styled(DialogContent)(({ theme }) => {
  const t = theme as MikeTheme
  const mediumGrey = t.palette.mediumGrey?.main ?? '#ccc'
  const darkGrey = t.palette.darkGrey?.main ?? '#666'
  return {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(10),
    minWidth: theme.spacing(70),
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    overflowY: 'auto',
    scrollbarWidth: 'thin' as any,
    scrollbarColor: `${darkGrey} ${mediumGrey}`,
    '&::-webkit-scrollbar': {
      width: 10,
      borderRadius: '4px 4px',
      zIndex: 1
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '4px 4px',
      backgroundColor: darkGrey,
      zIndex: 1
    }
  }
})

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  zIndex: 11,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.background.paper,
  boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.16)',
  height: theme.spacing(8),
  width: '100%'
}))

export const StyledUploadButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1)
}))

export const StyledUploadForm = styled('div')(({ theme }) => ({
  padding: theme.spacing(0)
}))

export const StyledUploadTitle = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1)
}))
